import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useStaffAsPatients = (params, options = {}) => {
  return useQuery(
    ["staffAsPatientsReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getStaffTreatments(), {
        params,
      });

      const composeResponse = {
        clinics: res.data.data.clinics,
        reportHeader: res.data.data.report_header,
        staffAsPatients: res.data.data.staff_as_patients || [],
        total: res.data.data.total,
      };
      return composeResponse;
    },
    options,
  );
};
